module.exports = __webpack_public_path__ + "static/media/menu.68055b32.svg";